// Contract cloud app <-> API (AD-31, AD-45), version app-v1. The binding form is JSON Schema in docs/protocol/app-v1;
// every type here is generated from it (src/generated/types.ts), the runtime checks are precompiled validators
// (src/generated/validators.ts, see validate.ts). Edit the schemas, then run `npm run generate -w @brewcore/app-contract`.
import { contract } from './generated/catalogs.js';
import type { AckResultCode } from './generated/types.js';

export type * from './generated/types.js';

export const APP_PROTOCOL_VERSION = contract.version;
export const WS_PATH: string = contract.wsPath;
/** The app shows "keine Rückmeldung" after this time without an ack (FR-20). */
export const COMMAND_TIMEOUT_MS: number = contract.commandTimeoutMs;
/** Server ping interval (AD-31). */
export const PING_INTERVAL_MS: number = contract.pingIntervalMs;
/** Largest message the API accepts from a browser. */
export const MAX_CLIENT_MESSAGE_BYTES: number = contract.maxClientMessageBytes;
/** WebSocket close codes: 4401 no or ended session, 4403 foreign Origin. */
export const WS_CLOSE = contract.closeCodes;

export const FINAL_ACK_RESULTS: ReadonlySet<AckResultCode> = new Set([
  'done',
  'failed',
  'rejected',
  'expired',
  'stale',
  'no_response',
]);

export function isFinalAck(result: AckResultCode): boolean {
  return FINAL_ACK_RESULTS.has(result);
}
